import React from 'react';
import { bool, shape, string } from 'prop-types';

const Chopping = ({
  className = '',
  notUseClass = false,
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 13.7998C18.4971 13.7998 18.9004 14.3373 18.9004 15C18.9003 15.6627 18.497 16.2002 18 16.2002C17.503 16.2001 17.1007 15.6626 17.1006 15C17.1006 14.3373 17.503 13.7999 18 13.7998Z" fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M21 6H19V9.15723C20.8944 9.77737 22 12.1672 22 15C22 18.3 20.5 21 18 21C15.758 21 14.3207 18.8284 14.0479 16H13C12.4 16 12 15.6 12 15C12 14.4 12.4 14 13 14H14.0479C14.2776 11.6181 15.3333 9.70283 17 9.15723V6H13V9.1748C13.3538 9.30097 13.6773 9.48507 14 9.7002C13.5001 10.1002 13.0998 10.6999 12.7998 11.2998C12.4999 11.0999 12.2999 11 12 11C10.9 11 10 12.6 10 15C10 17.4 10.9 19 12 19C12.2999 19 12.4999 18.9001 12.7998 18.7002C13.0998 19.4001 13.5001 19.8998 14 20.2998C13.4 20.6998 12.8 21 12 21C9.75796 21 8.32069 18.8284 8.04785 16H7C6.4 16 6 15.6 6 15C6 14.4 6.4 14 7 14H8.04785C8.27762 11.6181 9.33332 9.70283 11 9.15723V6H7V9.1748C7.3538 9.30097 7.67731 9.48507 8 9.7002C7.50007 10.1002 7.09978 10.6999 6.7998 11.2998C6.49993 11.0999 6.29992 11 6 11C4.9 11 4 12.6 4 15C4 17.4 4.9 19 6 19C6.29992 19 6.49993 18.9001 6.7998 18.7002C7.09978 19.4001 7.50007 19.8998 8 20.2998C7.4 20.6998 6.8 21 6 21C3.5 21 2 18.3 2 15C2 12.1672 3.10561 9.77737 5 9.15723V6H3V4H21V6ZM18 11C16.9 11 16 12.6 16 15C16 17.4 16.9 19 18 19C19.1 19 20 17.4 20 15C20 12.6 19.1 11 18 11Z" fill="currentColor" />
  </svg>
);

Chopping.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default Chopping;
